import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Guidingprinciples = ({
  heading = 'Our Guiding Principles',
  feature1Title = 'Customer Centricity',
  feature1Description = 'Instead of focusing on our competition, we focus on serving our customers.',
  feature1ImgSrc = 'https://images.pexels.com/photos/6931199/pexels-photo-6931199.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  feature1ImgAlt = 'Customer Centricity',
  feature2Title = 'Drive for Innovation',
  feature2Description = 'We ensure continuous innovation to create value for customers.',
  feature2ImgSrc = 'https://images.unsplash.com/photo-1654009603731-20b6d7536002?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  feature2ImgAlt = 'Drive for Innovation',
  feature3Title = 'Quality Without Compromise',
  feature3Description = 'We do not stop at delivering the best, we make it even better.',
  feature3ImgSrc = 'https://images.unsplash.com/photo-1735494033690-c74aa2641fb9?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  feature3ImgAlt = 'Quality Without Compromise',
  feature4Title = 'Sustainable Development',
  feature4Description = 'We think long term and ensure that our results add positive value.',
  feature4ImgSrc = 'https://images.pexels.com/photos/6676154/pexels-photo-6676154.jpeg?auto=compress&cs=tinysrgb&w=600',
  feature4ImgAlt = 'Sustainable Development',
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const features = [
    {
      title: feature1Title,
      description: feature1Description,
      imgSrc: feature1ImgSrc,
      imgAlt: feature1ImgAlt,
    },
    {
      title: feature2Title,
      description: feature2Description,
      imgSrc: feature2ImgSrc,
      imgAlt: feature2ImgAlt,
    },
    {
      title: feature3Title,
      description: feature3Description,
      imgSrc: feature3ImgSrc,
      imgAlt: feature3ImgAlt,
    },
    {
      title: feature4Title,
      description: feature4Description,
      imgSrc: feature4ImgSrc,
      imgAlt: feature4ImgAlt,
    },
  ];

  return (
    <Container fluid className="py-5">
      <Row className="justify-content-center">
        <Col md={10}>
          <h1 className="text-center mb-5">{heading}</h1>
          <Row className="align-items-center">
            <Col md={6}>
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center mb-3 p-3"
                  style={{
                    cursor: 'pointer',
                    borderLeft: activeTab === index ? '5px solid black' : '5px solid transparent',
                    transition: 'all 0.3s ease-in-out',
                  }}
                  onMouseEnter={() => setActiveTab(index)} // Set active tab on hover
                  onMouseLeave={() => setActiveTab(activeTab)} // Keep the hover effect
                >
                  <Card className="border-0 w-100">
                    <Card.Body>
                      <Card.Title className="fw-bold fs-3">{feature.title}</Card.Title>
                      <Card.Text>{feature.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </Col>
            <Col md={6} className="text-center">
              <div
                style={{
                  width: '100%',
                  maxWidth: '500px',
                  height: '660px',
                  overflow: 'hidden',
                  margin: '0 auto',
                }}
              >
                <img
                  src={features[activeTab].imgSrc}
                  alt={features[activeTab].imgAlt}
                  className="img-fluid rounded shadow"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

Guidingprinciples.propTypes = {
  heading: PropTypes.string,
  feature1Title: PropTypes.string,
  feature1Description: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
  feature1ImgAlt: PropTypes.string,
  feature2Title: PropTypes.string,
  feature2Description: PropTypes.string,
  feature2ImgSrc: PropTypes.string,
  feature2ImgAlt: PropTypes.string,
  feature3Title: PropTypes.string,
  feature3Description: PropTypes.string,
  feature3ImgSrc: PropTypes.string,
  feature3ImgAlt: PropTypes.string,
  feature4Title: PropTypes.string,
  feature4Description: PropTypes.string,
  feature4ImgSrc: PropTypes.string,
  feature4ImgAlt: PropTypes.string,
};

export default Guidingprinciples;
